module.exports = __webpack_public_path__ + "img/carritodecompras.e9677acc.png";